import Auth from "./auth";
import isLoading from "./isLoading";
import ACTIVE_MENU from "./activeMenu";
import AUTH_TOKEN from "./authToken";
import PROJECT_FLAG from "./projectFlag";
import { combineReducers } from "redux"

const rootReducer = combineReducers({
    Auth:Auth,
    IsLoading:isLoading,
    ActiveMenu: ACTIVE_MENU,
    AuthToken: AUTH_TOKEN,
    ProjectFlag: PROJECT_FLAG,
});

export default rootReducer;